import * as React from 'react';
import React__default from 'react';

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;

var _excluded = ["color", "size", "style"];
var Icon = (function (SvgComponent) {
  return /*#__PURE__*/React__default.forwardRef(function (props, ref) {
    var _props$color = props.color,
        color = _props$color === void 0 ? 'currentColor' : _props$color,
        _props$size = props.size,
        size = _props$size === void 0 ? '1em' : _props$size,
        _props$style = props.style,
        style = _props$style === void 0 ? {} : _props$style,
        otherProps = objectWithoutPropertiesLoose(props, _excluded);

    return /*#__PURE__*/React__default.createElement(SvgComponent, _extends_1({
      ref: ref,
      fill: color,
      width: size,
      height: size,
      style: _extends_1({}, style)
    }, otherProps));
  });
});

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M635.819 15.36c274.261 68.437 441.258 346.197 372.821 620.544-68.352 274.261-346.197 441.173-620.544 372.736C113.749 940.203-53.077 662.443 15.36 388.181 83.797 113.877 361.515-53.12 635.819 15.36zm-10.326 41.387c-251.392-62.72-506.026 90.282-568.746 341.76C-5.973 649.94 146.944 904.49 398.42 967.253c251.478 62.72 506.155-90.282 568.832-341.674 62.72-251.435-90.325-506.112-341.76-568.832zm90.411 621.866a272.213 272.213 0 0059.264-7.381 6326.735 6326.735 0 0039.552-9.045c13.312-3.072 21.888-5.248 25.813-6.486 3.968-1.237 6.315-5.034 7.083-11.434.768-6.4 1.152-11.478 1.152-15.19 0-52.138-6.315-96.725-18.987-133.76-10.666-31.317-22.698-54.485-36.096-69.461l-31.701 59.307c11.392 11.989 21.76 29.013 31.019 51.114 10.453 29.44 15.701 48.086 15.701 55.808 0 2.603-11.776 6.315-35.413 11.094a195.925 195.925 0 01-28.928 4.992 284.587 284.587 0 01-20.608.81c-10.923 0-21.888-2.346-32.854-6.954-8.021-4.011-12.245-14.294-12.714-30.806l-1.622-17.109a2.048 2.048 0 00-.938-.256c-1.707 0-3.328 2.133-4.864 6.4-1.536 4.224-3.414 12.63-5.547 25.173-2.133 12.63-3.328 21.76-3.456 27.563-.17 5.803-.256 10.027-.256 12.63-.299 20.991 3.797 34.047 12.288 39.125 9.728 8.789 23.765 13.44 42.112 13.866zm-126.336 0v-71.68H510.72v71.68h78.848zM270.421 521.472c54.187-4.65 81.28-25.216 81.28-61.824 0-2.773-.469-4.779-1.408-5.973a209.75 209.75 0 00-20.821-3.286c-9.13-1.237-15.19-3.413-18.304-6.442 2.005-4.822 4.779-10.539 8.363-17.28l12.501-23.723h-.725c-6.614 0-19.883 10.496-39.808 31.488-5.12 7.893-8.918 14.592-11.435 20.139a35.925 35.925 0 00-3.84 14.592c0 7.082 1.707 11.818 5.12 14.08a17.664 17.664 0 008.192 2.346c3.627.299 7.253.555 10.752.683 3.541.17 6.656.47 9.259.939 2.645.426 3.968 1.408 3.968 2.773 0 5.248-18.134 15.19-54.4 29.867a29.867 29.867 0 0011.306 1.621zm139.094 48.64l-.768 2.901c-.854 2.646-2.091 4.352-3.584 5.163-6.955 4.95-21.888 8.49-44.8 10.667-22.912 2.133-40.704 3.242-53.334 3.242-46.464 0-74.922-3.754-85.418-11.264a36.48 36.48 0 01-16.427-29.482c0-2.134.896-8.832 2.773-20.054 1.835-11.178 3.115-19.328 3.84-24.533.683-5.12 1.024-8.875 1.024-11.221v-1.835l-.938-.256c-4.779.17-14.934 14.507-30.55 43.093-9.386 18.347-14.122 38.187-14.122 59.478 0 47.53 46.933 71.253 140.714 71.253 9.259 0 35.243-2.133 77.91-6.57 42.666-4.395 65.237-12.8 67.712-25.131a152.32 152.32 0 00.682-12.928c.171-6.187.214-14.208.214-24.107V417.323l17.834-38.4-21.29-22.955-3.926-45.355-50.474 37.248 13.013 47.232V570.07z"
});

function SvgKwd(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "KWD_svg__icon",
    width: 200,
    height: 200,
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _ref);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKwd);

var ForwardIcon = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default.createElement(ForwardRef, _extends_1({}, props, {
    ref: ref
  }));
});
var KuFoxIcons = Icon(ForwardIcon);
KuFoxIcons.displayName = 'KWDOutlined';

export default KuFoxIcons;
